const addSpaceToNumber = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
export { addSpaceToNumber as default }



// WEBPACK FOOTER //
// ./src/blocks/barrels/format-number.js